import React from 'react'
import { useAppSelector } from '../../../../store/hooks'
import PredictionReview from '../../PredictionsReview/PredictionReview'
import InferenceAALSubView from './InferenceAALSubview'

const ReviewPhase: React.FC = () => {
  const editingPrediction = useAppSelector((state) => state.prediction.editingPrediction)

  return (
    <div
      className="d-flex flex-column flex-fill rounded-3 overflow-hidden"
      style={{ minHeight: 0, background: '#1a1a1a' }}
    >
      {/* {!editingPrediction && (
        <div
          className="d-flex align-items-center justify-content-between flex-shrink-0 border-bottom"
          style={{
            background: 'linear-gradient(135deg, #2a2a2a 0%, #1f1f1f 100%)',
            borderBottomColor: 'rgba(147, 51, 234, 0.2)',
            padding: '1rem 1.5rem',
          }}
        >
          <div>
            <h2
              className="text-white fw-semibold d-flex align-items-center gap-2 mb-1"
              style={{ fontSize: '1.1rem' }}
            >
              <span
                className="d-flex align-items-center justify-content-center rounded-2 text-white"
                style={{
                  width: 32,
                  height: 32,
                  background: 'linear-gradient(135deg, #9333ea 0%, #c084fc 100%)',
                  fontSize: '0.9rem',
                }}
              >
                <FaEye />
              </span>
              Review AI Predictions
            </h2>
            <p className="mb-0" style={{ color: '#b0b0b0', fontSize: '0.85rem', lineHeight: 1.4 }}>
              Review and validate AI-generated labels across confidence levels. Focus on uncertain
              predictions for maximum impact.
            </p>
          </div>
        </div>
      )} */}

      <div
        className="d-flex flex-column flex-fill h-100"
        style={{ minHeight: 0, background: '#1a1a1a', overflow: 'visible' }}
      >
        {editingPrediction ? <PredictionReview /> : <InferenceAALSubView />}
      </div>
    </div>
  )
}

export default ReviewPhase
